export default function Certifications() {
    return (
        <section id="certifications" className="certifications--section">
            <div className="certifications--header">
                <p className="sub--title">Meine Zertifikate</p>
                <h2 className="section--heading">Zertifikate</h2>
            </div>

            <div className="certifications--container">
                <div className="certifications--card">
                    <div className="certifications--img">
                        <img src="./img/SAP-BTP-Admin.png" alt="SAP Certified - SAP BTP Administrator" />
                    </div>
                    <div className="certifications--content">
                        <h3>SAP Certified: SAP BTP Administrator</h3>
                        <p>Ausgestellt von SAP</p>
                        <p className="text-sm">Zertifiziert 2026</p>
                    </div>
                </div>
                <div className="certifications--card">
                    <div className="certifications--img">
                        <img src="./img/SAP-CAPM.png" alt="SAP Certified - Backend Developer - SAP Cloud Application Programming Model" />
                    </div>
                    <div className="certifications--content">
                        <h3>SAP Certified: Backend Developer &ndash; SAP Cloud Application Programming Model</h3>
                        <p>Ausgestellt von SAP</p>
                        <p className="text-sm">Zertifiziert 2026</p>
                    </div>
                </div>
                <div className="certifications--card">
                    <div className="certifications--img">
                        <img src="./img/terraform-associate.png" alt="HashiCorp Terraform Associate (004)" />
                    </div>
                    <div className="certifications--content">
                        <h3>HashiCorp Certified: Terraform Associate (004)</h3>
                        <p>Ausgestellt von HashiCorp</p>
                        <p className="text-sm">Zertifiziert 2026</p>
                    </div>
                </div>
                <div className="certifications--card">
                    <div className="certifications--img">
                        <img src="./img/dp-900.png" alt="Microsoft DP-900" />
                    </div>
                    <div className="certifications--content">
                        <h3>Microsoft Certified: Azure Data Fundamentals</h3>
                        <p>Ausgestellt von Microsoft</p>
                        <p className="text-sm">Zertifiziert 2025</p>
                        <a
                            href="https://learn.microsoft.com/en-us/credentials/certifications/exams/dp-900/"
                            target="_blank"
                            rel="noreferrer"
                            className="portfolio--link"
                        >
                            Zertifikat ansehen
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 19" fill="none">
                                <path
                                    d="M4.66667 1.66675H18V15.0001M18 1.66675L2 17.6667L18 1.66675Z"
                                    stroke="currentColor"
                                    strokeWidth="2.66667"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
                <div className="certifications--card in-progress">
                    <div className="certifications--img">
                        <img src="./img/azure-az104.png" alt="Microsoft Azure Administrator (AZ-104)" />
                    </div>
                    <div className="certifications--content">
                        <h3>Microsoft Certified: Azure Administrator Associate (AZ-104)</h3>
                        <p>Ausgestellt von Microsoft</p>
                        <p className="text-sm status">In Bearbeitung</p>
                    </div>
                </div>

            </div>
        </section>
    );
}
